/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignments layout styles
 *
 * @file assignmentsLayoutStyles.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';
import { createScopedClasses, createScopedStyles } from '../../../assets/styles/createScopedStyles';

const assignmentsLayoutStyles = {
  root: {
    width: '100%'
  },
  paneRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    width: '100%',
    alignItems: 'flex-start',

    [mixins['mlg-min']]: {
      gridTemplateColumns: '1fr 1fr'
    }
  },
  paneRowSingle: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    width: '100%',
    alignItems: 'flex-start'
  },
  listPane: {
    borderRadius: 16,
    boxSizing: 'border-box',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  emptyStateContainer: {
    borderRadius: 16,
    backgroundColor: mixins.chalkWhiteFont,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
};

export const classes = createScopedClasses('aet-assignments-layout', assignmentsLayoutStyles);

export const scopedStyles = createScopedStyles(assignmentsLayoutStyles, classes);

export const AssignmentsLayoutStylesRoot = styled('div')(scopedStyles);

export default assignmentsLayoutStyles;
